module.exports = "/_next/static/images/OnboardingDesktop-eaac3d13241f20bb77644e07a03a1e26.png";